import { useFlags } from "launchdarkly-react-client-sdk";

import { useHireOfferManagementFlag } from "./useHireOfferManagementFlag";

/**
 * The `hireEsignature` LaunchDarkly release flag: sending offer documents for
 * signature with DocuSign.
 *
 * Off, offers send by Compono message alone and the frontend shows nothing of
 * e-signature: no sending-method step, signatories or signing order in the
 * send flow, no envelopes among the sent documents, no signature marks or
 * placeholders in the document template settings, and no Settings →
 * E-signature. The server keeps its own checks either way.
 *
 * Requires offer management as well: e-signature is part of it.
 */
export const useHireEsignatureFlag = (): boolean => {
  const { hireEsignature } = useFlags();
  const offersEnabled = useHireOfferManagementFlag();
  return Boolean(hireEsignature) && offersEnabled;
};
